import React from "react";

import PropTypes from "prop-types";
import useFormPrefix from "../hooks/useFormPrefix";
import FormPrefixContext from "./FormPrefixContext";

export const FormPrefixProvider = ({ prefix, children, shouldReset }) => {
	const currentPrefix = useFormPrefix();

	return (
		<FormPrefixContext.Provider
			value={
				currentPrefix && !shouldReset
					? `${currentPrefix}.${prefix}`
					: prefix
			}
		>
			{children}
		</FormPrefixContext.Provider>
	);
};

FormPrefixProvider.propTypes = {
	/**
	 * The prefix to use for nested forms and fields (especially for react-hook-form).
	 */
	prefix: PropTypes.string.isRequired,
	/**
	 * The wrapped components that will get access to the context.
	 */
	children: PropTypes.node,
	/**
	 * Reset previous prefix
	 */
	shouldReset: PropTypes.bool
};

FormPrefixProvider.defaultProps = {
	children: null,
	shouldReset: false
};
